const { showError } = require('../libs/helper');
var qs = require('qs');

module.exports = {
    validasi: async (g, data) => {
        await g.$http({
            url: process.env.VUE_APP_SUBFOLDER_API2 + 'sensus-pengguna/store-validasi-unfound',
            method: 'post',
            data: qs.stringify(data),
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
        })
            .then(res => {
                g.$router.push({ name: 'validasiBelumTercatat' })
            })
            .catch(err => {
                showError(g, err, `Error Submit Form`)
            })
    },
}